import type { AuxNdoc } from "@/types/auxNdoc";
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useAuxNdoc() {
  const store = useStore(key);
  let lstAuxNdoc: Ref<AuxNdoc[]> = ref([]);

  async function getAuxNdoc(empresa: string) {
    try {
      await axios
        .get(
          store.state.url + "api/AuxNdoc/GetOtMantencion?company=" + empresa,
          {
            headers: {},
          }
        )
        .then((response) => {
          if (response.status == 200) {
            lstAuxNdoc.value = response.data as AuxNdoc[];
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return { getAuxNdoc, lstAuxNdoc };
}
